<template>
  <div class="draft-template-modal">
    <Modal
      :show="show"
      :action-text="isTemplateHidden ? 'Yes, Publish Template' : 'Yes, Make it a Draft'"
      cancel-text=""
      @action="$emit('update', !isTemplateHidden)"
      @close="$emit('close', $event)"
    >
      <template #title>
        <span v-if="isTemplateHidden">
          Publish Draft Template
        </span>

        <span v-else>
          Make Published Template a Draft
        </span>
      </template>

      <template #content>
        <span v-if="isTemplateHidden">
          Published Templates can be seen and used by everyone in your organization.
          Only publish a Template once it's complete and ready to use.
        </span>

        <span v-else>
          Making this Template a Draft means it will not be available for use by anyone
          in your organization. Other Admins will still be able to view and edit it.
        </span>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/shared/Modal.vue';

export default {
  name: 'DraftTemplateModal',
  components: { Modal },
  props: {
    show: { type: Boolean, default: false },
    isTemplateHidden: { type: Boolean, default: false },
  },
  emits: ['close', 'update'],
};
</script>
